import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit } from '@angular/core';
import { UserService } from '../service/auth/user.service';

@Component({
    selector: 'app-registration',
    templateUrl: './registration.component.html',
    styles: []
})
export class RegistrationComponent implements OnInit {
    constructor(
        public userService: UserService,
        private toastr: ToastrService,
        private router: Router
    ) { }

    ngOnInit() {
        this.userService.formModel.reset();
    }

    onSubmit() {
        this.userService.register().subscribe(
            (res: any) => {
                this.userService.formModel.reset();
                this.toastr.success('Thành công !', 'Đăng ký hoàn tất');
                this.router.navigate(['./techbyte/admin/login']);
            },
            err => {
                this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
            }
        );
    }
}